export const TRANSMITTER_PERMISSIONS = {
  read: 'operations.transmitters.read',
  create: 'operations.transmitters.create',
  edit: 'operations.transmitters.edit',
  reassign: 'operations.transmitters.reassign',
  delete: 'operations.transmitters.delete',
  manageImages: 'operations.transmitters.images',
  pushFirmware: 'operations.transmitters.firmware',
  pushConfigs: 'operations.transmitters.configs',
  resetSim: 'operations.transmitters.reset_sim',
  diagnostics: 'operations.transmitters.diagnostics',
} as const;

